import * as React from "react";
import clsx from "clsx";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import * as Router from "@reach/router";
import { API, graphqlOperation } from "aws-amplify";
import Divider from "@material-ui/core/Divider";
import Drawer, { DrawerProps } from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// import HomeIcon from "@material-ui/icons/Home";
import PeopleIcon from "@material-ui/icons/People";
import DnsRoundedIcon from "@material-ui/icons/DnsRounded";
import PermMediaOutlinedIcon from "@material-ui/icons/PhotoSizeSelectActual";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TimerIcon from "@material-ui/icons/Timer";
import SettingsIcon from "@material-ui/icons/Settings";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup";
import { Omit } from "@material-ui/types";
import ListItemLink from "components/atoms/ListItemLink";
import { useSelector, useDispatch } from "react-redux";
import User from "features/user/userSlice";
import { navigate } from "@reach/router";

const styles = (theme: Theme) =>
  createStyles({
    categoryHeader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    categoryHeaderPrimary: {
      color: theme.palette.common.white,
    },
    item: {
      paddingTop: 1,
      paddingBottom: 1,
      color: "rgba(255, 255, 255, 0.7)",
      "&:hover,&:focus": {
        backgroundColor: "rgba(255, 255, 255, 0.08)",
      },
    },
    itemCategory: {
      backgroundColor: "#232f3e",
      boxShadow: "0 -1px 0 #404854 inset",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    firebase: {
      fontSize: 24,
      color: theme.palette.common.white,
    },
    itemActiveItem: {
      color: "#4fc3f7",
    },
    itemPrimary: {
      fontSize: "inherit",
    },
    itemIcon: {
      minWidth: "auto",
      marginRight: theme.spacing(2),
    },
    divider: {
      marginTop: theme.spacing(2),
    },
  });

export interface NavigatorProps
  extends Omit<DrawerProps, "classes">,
    WithStyles<typeof styles> {
  showID?: string;
  categories: any[];
}

function Navigator(props: NavigatorProps) {
  const { classes, categories, showID, ...other } = props;
  const dispatch = useDispatch();
  const { selectedShow, editableShows, groups } = useSelector(
    (state: any) => state.user
  ) as any;

  const [active, setActive] = React.useState("ショーを選ぶ");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickMenu = (show: any) => {
    dispatch(User.actions.setShow(show));
    navigate(`/cms/shows/${show.id}`);
    setAnchorEl(null);
  };

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem
          className={clsx(classes.firebase, classes.item, classes.itemCategory)}
        >
          {selectedShow ? selectedShow.name : "ショーを選択してください"}
        </ListItem>
        {editableShows.length > 1 && (
          <>
            <ListItem
              onClick={handleClick}
              className={clsx(classes.item, classes.itemCategory)}
            >
              オンラインショー選択
            </ListItem>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {editableShows.map((show: any, key: number) => (
                <MenuItem key={key} onClick={() => handleClickMenu(show)}>
                  {show.name}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
        {groups.includes("Admins") && (
          <>
            <ListItemLink
              to="/cms/admin/shows"
              text="オンラインショー管理"
              itemClass={clsx(classes.item, classes.itemCategory)}
              onClick={setActive}
            />

            {/* <ListItemLink
              to="/cms/admin/users"
              text="ユーザ管理"
              itemClass={clsx(classes.item, classes.itemCategory)}
              onClick={setActive}
            /> */}

            <ListItemLink
              to="/cms/admin/pages"
              text="ページ管理"
              itemClass={clsx(classes.item, classes.itemCategory)}
              onClick={setActive}
            />

            <ListItemLink
              to="/cms/admin/toppages"
              text="トップページ管理"
              itemClass={clsx(classes.item, classes.itemCategory)}
              onClick={setActive}
            />
            <ListItemLink
              to="/cms/admin/boothBoatTypes"
              text="ブース検索ボート種別管理"
              itemClass={clsx(classes.item, classes.itemCategory)}
              onClick={setActive}
            />

            <ListItemLink
              to="/cms/admin/boothBoatBrands"
              text="ブース検索ブランド管理"
              itemClass={clsx(classes.item, classes.itemCategory)}
              onClick={setActive}
            />
          </>
        )}

        {selectedShow &&
          categories.map(({ id, children }) => (
            <React.Fragment key={id}>
              <ListItem className={classes.categoryHeader}>
                <ListItemText
                  classes={{
                    primary: classes.categoryHeaderPrimary,
                  }}
                >
                  {`${id} : ${selectedShow.name}`}
                </ListItemText>
              </ListItem>
              {children.map((item: any) => (
                <ListItemLink
                  key={item.id}
                  text={item.id}
                  icon={item.icon}
                  to={`/cms/shows/${selectedShow.id}${item.to}`}
                  itemClass={clsx(
                    classes.item,
                    item.id === active && classes.itemActiveItem
                  )}
                  itemIconClass={classes.itemIcon}
                  itemTextClasses={{
                    primary: classes.itemPrimary,
                  }}
                  onClick={setActive}
                />
              ))}
              <Divider className={classes.divider} />
            </React.Fragment>
          ))}
      </List>
    </Drawer>
  );
}

export default withStyles(styles)(Navigator);
